import { Controller } from "@hotwired/stimulus"

// Keeps start, end and duration of the planner form consistent: typing a
// duration moves the end, changing a date recomputes the duration. Dates
// are inclusive on both sides, so a one-day item starts and ends the same day.
const DAY_MS = 86400000

export default class extends Controller {
  static targets = ["start", "end", "duration"]

  syncFromDuration() {
    const start = this.parse(this.startTarget.value)
    const days = parseInt(this.durationTarget.value, 10)
    if (start === null || !(days >= 1)) return
    this.endTarget.value = this.iso(start + (days - 1) * DAY_MS)
  }

  syncFromDates() {
    const start = this.parse(this.startTarget.value)
    const end = this.parse(this.endTarget.value)
    if (start === null) return
    if (end === null) {
      this.syncFromDuration()
      return
    }
    if (end < start) {
      this.endTarget.value = this.iso(start)
      this.durationTarget.value = 1
      return
    }
    this.durationTarget.value = Math.round((end - start) / DAY_MS) + 1
  }

  parse(value) {
    if (!value) return null
    const [y, m, d] = value.split("-").map(Number)
    return Date.UTC(y, m - 1, d)
  }

  iso(ms) { return new Date(ms).toISOString().slice(0, 10) }
}
